<template>
    <div class="ah-page loan-list-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>借款管理</h1>
                    </div>
                    <div class="actions">
                        <el-button @click="onExport">匯出Excel</el-button>
                        <el-button type="highlight" @click="onAdd" icon="el-icon-plus">新增借款合約</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel" style="margin-top: 25px">
                <div class="panel-body">
                    <TableView
                        :datas="datas"
                        :loading="isLoading"
                        :pageSize="queryParams.PageSize"
                        :currPage="queryParams.PageNum"
                        :showRefreshButton="true"
                        @refresh="updateData"
                    />
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        :small="isMobile()"
                        class="pagination"
                        @current-change="onPageChange"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TableView from './TableView.vue';
import ContractExcelMixins from './ContractExcelMixins';

export default {
    mixins: [ContractExcelMixins],
    components: { TableView },
    data() {
        return {
            datas: [],
            isLoading: false,
            queryParams: {
                PageSize: 25,
                PageNum: 1,
            },
            totalDataCount: 0,
        };
    },
    mounted() {
        this.updateData();
    },
    methods: {
        onAdd() {
            this.$router.push({ name: 'loan-management-add' });
        },
        onPageChange() {
            this.updateData();
        },
        async updateData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    method: 'GET',
                    url: 'LoanReceipt/GetLoanReceiptList',
                    params: this.queryParams,
                });
                this.datas = resp.data.items;
                this.totalDataCount = resp.data.totalNum;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
